
import { useStore } from 'vuex'
import { onMounted, reactive, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import { callApi, callPostApi, sendMessageToFlutter, sendUrlToAndroid } from '@/api/api'
import defaultFeatureIcon from '@/assets/images/mobile/feature-icon-field.png'
import loadingFeatureCatiguryIcon from '@/assets/images/mobile/feature-catigury-loading.png'
import { isAndroid, isIOS, toHttpsAbsolute,shuffle } from '@/utils/utils'

export default {
	name: 'FeaturesDialog',
	setup(props) {
		const store = useStore()
		const local = computed(() => store.state.translation.locale)
		


		function closeTab_() {
            sendMessageToFlutter('clickBack')
        }

		// ---------------------- inside dialog

		const router = useRouter()
        const route = useRoute()
        const data = reactive({
            encryptedToken: decodeURIComponent(route.query.id as any ?? ' ').replace(/\s/g, '+').replace(/%2B/g, '+'),
        })
        const state = reactive({
            loadingFeatures: false,
        })

        const features = computed(() => {
            if ((store.state.customFeatures.features2 === null)&&state.loadingFeatures) {
                let loadingCatigories = Array.from({ length: 8 }, () => ({ title: local.value.defaultFeatureCatiguryName, image_link: loadingFeatureCatiguryIcon,url:'',load:false }))
                return  loadingCatigories
            } else {
                return shuffle(store.state.customFeatures.features2)
            }
        })


		const getAgentType = computed(()=> {
            if(isAndroid()) return 1;
            else if(isIOS()) return 2;
            else return 0
        })

        const featureLoadingIcon_ = computed(() => {
            return loadingFeatureCatiguryIcon
        })

		onMounted(async () => {
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang ?? 'cn' })
            // // openComponent('showLoading')
            state.loadingFeatures = true
            // if (data.encryptedToken) {
                const res = await callApi('/ads-external-links', 'GET', data.encryptedToken as any, route.query.lang + '' || 'cn')
                .finally(() => {state.loadingFeatures = false})
                if (res.isSuccess) {
                    //  setCatiguries ----------------------------------------------------------
                    let defaultCatigories = Array.from({ length: 8 }, () => ({ title: '我是个功能', image_link: '', url:'',load:true }))
                    let res4 = res.data.map((element) => ({...element,load:false})).sort((a,b) => (a.sorting_order - b.sorting_order))

                    if(!res4.length) res4 = defaultCatigories
                    await store.dispatch('customFeatures/setFeatures2', res4)
                    // --------------------------------------------------------------------------------------------
                } else {
                    await store.dispatch('customFeatures/setFeatures2', null)

                    router.push(
                        {
                            path: '/external-links-error',
                            query: { lang: route.query.lang ?? 'cn',title: local.value.external_links_error , external_links: '2' },
                        }
                    )
                }
        });

        function toggleComponent(name: string) {
            if (name in state) {
                state[name] = !state[name]
            }
        }

        const closeComponent = (name: string) => {
            if (name in state) {
                state[name] = false
            }
        }

        const openComponent = (name: string) => {
            if (name in state) {
                state[name] = true
            }
        }

        const onIconFeatureError = (e: Event) => {
            const target = e.target as HTMLImageElement;
            target.src = defaultFeatureIcon;
        };

        const onIconFeatureLoading = (id:number) => {
            store.dispatch('customFeatures/setLoadFeatureImg2',{id:id})
        }

		const jumpUrl = async (url:string,urlId=null) => {
            if(urlId === null) {
                sendUrlToAndroid(JSON.stringify({method:'browserOpenUrl', url:url}))
            } else {
                let body = {
                id:urlId
             }
            const res = await callPostApi('/external-links/click', 'POST', JSON.stringify(body), data.encryptedToken)
            .finally(() => { 
                sendUrlToAndroid(JSON.stringify({method:'browserOpenUrl', url:url}))
            })
            if(res.isSuccess) {
                console.log('clicked success')
            } else {
                console.log('clicked faild')
            }
            }
        }

		return {
			local,
			props,
			data,
            state,
            toggleComponent,
            closeComponent,
            openComponent,
            onIconFeatureError,
            features,
            jumpUrl,
            closeTab_,
            getAgentType,
            onIconFeatureLoading,
            featureLoadingIcon_,
            toHttpsAbsolute,
		}
	}
}
